import { Base } from "./base";

export class Role extends Base {
    RoleID?: number;
    Title?: string;
}